export const TRADES = [
  { key: "av_low_voltage", label: "AV / Low-Voltage" },
  { key: "electrical", label: "Electrical" },
  { key: "plumbing", label: "Plumbing" },
  { key: "hvac", label: "HVAC" },
  { key: "general_contractor", label: "General Contractor" },
  { key: "security_alarm", label: "Security & Alarm" },
  { key: "fire_life_safety", label: "Fire & Life Safety" },
  { key: "networking_it", label: "Networking / IT" },
  { key: "solar", label: "Solar / Renewables" },
  { key: "landscaping", label: "Landscaping / Irrigation" },
  { key: "roofing", label: "Roofing" },
  { key: "appliance_repair", label: "Appliance Repair" },
];

export const tradeLabel = (key) => TRADES.find((t) => t.key === key)?.label || key;
